import * as billingSagas from './billing/sagas';
import * as emailConfirmationSagas from './emailConfirmation/sagas';
import * as loginSagas from './login/sagas';
import * as passwordResetSagas from './passwordReset/sagas';
import * as requestPasswordResetSagas from './requestPasswordReset/sagas';
import * as signupSagas from './signup/sagas';
import * as resendEmailConfirmationSagas from './resendEmailConfirmation/sagas';
import * as userSagas from './user/sagas';
import * as upgradeSubscriptionSagas from './upgradeSubscription/sagas';
import * as deleteAccountSagas from './deleteAccount/sagas';
import * as newsletterOptInSagas from './newsletterOptIn/sagas';

export const sagas = {
  ...billingSagas,
  ...deleteAccountSagas,
  ...emailConfirmationSagas,
  ...loginSagas,
  ...newsletterOptInSagas,
  ...passwordResetSagas,
  ...requestPasswordResetSagas,
  ...resendEmailConfirmationSagas,
  ...signupSagas,
  ...upgradeSubscriptionSagas,
  ...userSagas,
};
